import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/base/SectionTitle';
import { characters } from '@/mocks/drama';

export default function CastSection() {
  return (
    <section id="cast" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <Reveal>
          <SectionTitle
            eyebrow="角色关系"
            title="六个人物，撑起整部剧的关系网"
            description="看短剧最怕脸盲和记不住动机。下面把主要角色按“在故事里负责什么”整理清楚，每个人物都对应一种冲突来源，理解他们，反转就不难猜也不难懂。"
          />
        </Reveal>

        <div className="mt-10 grid gap-5 md:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {characters.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="group h-full overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
                <div className="flex items-center gap-4 p-5">
                  <div className="h-20 w-20 shrink-0 overflow-hidden rounded-full border-2 border-accent-300">
                    <img
                      src={item.avatar}
                      alt={`《漂亮的小姨子》角色 ${item.name} 的形象参考`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{item.name}</h3>
                    <p className="font-label text-xs text-primary-700">{item.role}</p>
                  </div>
                </div>
                <div className="px-5 pb-5">
                  <p className="font-body text-sm leading-relaxed text-foreground-700">{item.summary}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {item.keywords.map((word) => (
                      <span key={word} className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
                        {word}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}